import axios from 'axios';
import * as types from './AdminPromotionalItems.types';
import { showNotification } from './../../utils';
import * as loginActions from './../Login/Login.actions';
import * as selectors from './AdminPromotionalItems.selectors';
import * as dialog from './../common/dialog';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchPromotionalItems = () => (dispatch, getState) => {
    const pagination = selectors.getPagination(getState());
    const sort = selectors.getSort(getState());
    const search = selectors.getSearch(getState());
    const searchType = selectors.getSearchType(getState());

    let params = [];
    params.push('active-page=' + pagination.activePage);
    params.push('elements-per-page=' + pagination.elementsPerPage);
    params.push('sort-column=' + sort.column);
    params.push('sort-type=' + sort.type);
    params.push('search=' + search);
    params.push('search-type=' + searchType);

    dispatch({ type: types.FETCH_PROMOTIONAL_ITEMS, payload: null });
    axios.get(apiUrl + '/uthealth-promotional-item/admin-index?' + (params.length === 0 ? '' : '&' + params.join('&')),
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_PROMOTIONAL_ITEMS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_PROMOTIONAL_ITEMS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const fetchDepartments = () => (dispatch, getState) => {
    dispatch({ type: types.FETCH_DEPARTMENTS, payload: null });
    axios.get(apiUrl + '/uthealth-promotional-item/departments',
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_DEPARTMENTS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_DEPARTMENTS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const savePromotionalItem = () => (dispatch, getState) => {
    const promotionalItem = selectors.getPromotionalItem(getState());
    const imageFile = selectors.getImageFile(getState());

    if (promotionalItem.sku === undefined || promotionalItem.sku == null || promotionalItem.sku === '') {
        return showNotification('Complete information', 'Enter the Sku for the item', 'info');
    }
    if (promotionalItem.name === undefined || promotionalItem.name == null || promotionalItem.name === '') {
        return showNotification('Complete information', 'Enter the Name for the item', 'info');
    }
    if (promotionalItem.uthealth_department_id === undefined || promotionalItem.uthealth_department_id == null || promotionalItem.uthealth_department_id === '') {
        return showNotification('Complete information', 'Select a department for the item', 'info');
    }
    if (promotionalItem.current_inventory === undefined || promotionalItem.current_inventory == null || promotionalItem.current_inventory === '') {
        return showNotification('Complete information', 'Enter the Current Inventory for the item', 'info');
    }
    if (parseInt(promotionalItem.is_bundles) && (promotionalItem.pieces_per_bundle == null || promotionalItem.pieces_per_bundle === '')) {
        return showNotification('Complete information', 'Enter the Pieces per Bundle for the item', 'info');
    }
    if (promotionalItem.sku_charge === undefined || promotionalItem.sku_charge == null || promotionalItem.sku_charge === '') {
        return showNotification('Complete information', 'Enter the SKU Charge for the item', 'info');
    }
    if (promotionalItem.shipping_charge === undefined || promotionalItem.shipping_charge == null || promotionalItem.shipping_charge === '') {
        return showNotification('Complete information', 'Enter the Shipping Charge for the item', 'info');
    }
    if (promotionalItem.handling_charge === undefined || promotionalItem.handling_charge == null || promotionalItem.handling_charge === '') {
        return showNotification('Complete information', 'Enter the Handling Charge for the item', 'info');
    }
    if (promotionalItem.show_logos === undefined || promotionalItem.show_logos == null || promotionalItem.show_logos === '') {
        return showNotification('Complete information', 'Select the Logos Options field', 'info');
    }
    if (promotionalItem.id === undefined || promotionalItem.id === '') {
        if (imageFile === undefined || imageFile == null) {
            return showNotification('Complete information', 'Select an Image File for the item', 'info');
        }
    }

    let endpoint = null;
    if (promotionalItem.id && promotionalItem.id !== '') {
        endpoint = apiUrl + '/uthealth-promotional-item/update-post';
    } else {
        endpoint = apiUrl + '/uthealth-promotional-items';
    }

    var formData = new FormData();
    formData.append('id', promotionalItem.id);
    formData.append('sku', promotionalItem.sku);
    formData.append('name', promotionalItem.name);
    formData.append('description', promotionalItem.description);
    formData.append('uthealth_department_id', promotionalItem.uthealth_department_id);
    formData.append('current_inventory', promotionalItem.current_inventory);
    formData.append('personal_price', promotionalItem.personal_price);
    formData.append('manager_price', promotionalItem.manager_price);
    formData.append('sku_charge', promotionalItem.sku_charge);
    formData.append('shipping_charge', promotionalItem.shipping_charge);
    formData.append('handling_charge', promotionalItem.handling_charge);
    formData.append('vendor_product_code', promotionalItem.vendor_product_code && promotionalItem.vendor_product_code != null ? promotionalItem.vendor_product_code : '');
    formData.append('bullet1', promotionalItem.bullet1 && promotionalItem.bullet1 != null ? promotionalItem.bullet1 : '');
    formData.append('bullet2', promotionalItem.bullet2 && promotionalItem.bullet2 != null ? promotionalItem.bullet2 : '');
    formData.append('bullet3', promotionalItem.bullet3 && promotionalItem.bullet3 != null ? promotionalItem.bullet3 : '');
    formData.append('bullet4', promotionalItem.bullet4 && promotionalItem.bullet4 != null ? promotionalItem.bullet4 : '');
    formData.append('bullet5', promotionalItem.bullet5 && promotionalItem.bullet5 != null ? promotionalItem.bullet5 : '');
    formData.append('bullet6', promotionalItem.bullet6 && promotionalItem.bullet6 != null ? promotionalItem.bullet6 : '');
    formData.append('bullet7', promotionalItem.bullet7 && promotionalItem.bullet7 != null ? promotionalItem.bullet7 : '');
    formData.append('bullet8', promotionalItem.bullet8 && promotionalItem.bullet8 != null ? promotionalItem.bullet8 : '');
    formData.append('bullet9', promotionalItem.bullet9 && promotionalItem.bullet9 != null ? promotionalItem.bullet9 : '');
    formData.append('bullet10', promotionalItem.bullet10 && promotionalItem.bullet10 != null ? promotionalItem.bullet10 : '');
    formData.append('allow_utp', promotionalItem.allow_utp);
    formData.append('allow_uth', promotionalItem.allow_uth);
    formData.append('allow_manager', promotionalItem.allow_manager);
    formData.append('allow_personal', promotionalItem.allow_personal);
    formData.append('allow_coupa', promotionalItem.allow_coupa);
    formData.append('is_bundles', promotionalItem.is_bundles);
    formData.append('pieces_per_bundle', promotionalItem.pieces_per_bundle);
    formData.append('pricing', JSON.stringify(promotionalItem.pricing));
    formData.append('pricing_enabled', JSON.stringify(promotionalItem.pricing_enabled));
    formData.append('show_logos', promotionalItem.show_logos);
    if (imageFile && imageFile != null) {
        formData.append('image_file', imageFile);
    }

    dispatch({ type: types.SAVE_PROMOTIONAL_ITEM, payload: null });
    axios.post(endpoint, formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.SAVE_PROMOTIONAL_ITEM_SUCCESS, payload: response.data });
            dispatch(dialog.actions.hideDialog('form-modal'));
            showNotification('Item Saved', 'The item has been saved successfully', 'success');
            dispatch(fetchPromotionalItems());
            dispatch(resetPromotionalItem());
            dispatch(setImageFile(null));
        })
        .catch((error) => {
            dispatch({ type: types.SAVE_PROMOTIONAL_ITEM_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const deletePromotionalItem = () => (dispatch, getState) => {
    const idModal = selectors.getIdModal(getState());

    dispatch({ type: types.DELETE_PROMOTIONAL_ITEM, payload: null });
    axios.delete(apiUrl + '/uthealth-promotional-items/' + idModal,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.DELETE_PROMOTIONAL_ITEM_SUCCESS, payload: response.data });
            dispatch(dialog.actions.hideDialog('delete-modal'));
            showNotification('Item Deleted', 'The item has been deleted successfully', 'success');
            dispatch(fetchPromotionalItems());
        })
        .catch((error) => {
            dispatch({ type: types.DELETE_PROMOTIONAL_ITEM_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const uploadExcel = () => (dispatch, getState) => {
    const uploadFile = selectors.getUploadFile(getState());

    if (uploadFile == null) {
        return showNotification('Complete information', 'You need to select a file to upload', 'info');
    }

    var formData = new FormData();
    formData.append('file', uploadFile);

    dispatch({ type: types.UPLOAD_FILE, payload: null });
    axios.post(apiUrl + '/uthealth-promotional-item/upload-excel', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.UPLOAD_FILE_SUCCESS, payload: response.data });
            showNotification('File Uploaded', 'The file has been uploaded and processed successfully', 'success');
            dispatch(dialog.actions.hideDialog('upload-modal'));
            dispatch(fetchPromotionalItems());
        })
        .catch((error) => {
            dispatch({ type: types.UPLOAD_FILE_ERROR, payload: null });
            if (error.response && (error.response.status === 400)) {
                showNotification('Wrong Format', 'The file format is incorrect, please use the Master template that is downloaded from this section', 'warning', 6000);
            } else if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const setIdModal = (id) => (dispatch) => {
    dispatch({
        type: types.SET_ID_MODAL,
        payload: id
    });
}

export const setActivePage = (value) => (dispatch, getState) => {
    new Promise(resolve => {
        dispatch({
            type: types.SET_ACTIVE_PAGE,
            payload: value,
        });
        resolve();
    }).then(() => {
        dispatch(fetchPromotionalItems());
    });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}

export const setPromotionalItemField = (field, value) => (dispatch) => {
    dispatch({
        type: types.SET_PROMOTIONAL_ITEM_FIELD,
        payload: { field, value },
    })
}

export const setImageFile = (file) => (dispatch) => {
    dispatch({
        type: types.SET_IMAGE_FILE,
        payload: file,
    })
}

export const setUploadFile = (file) => (dispatch) => {
    dispatch({
        type: types.SET_UPLOAD_FILE,
        payload: file,
    })
}

export const setPromotionalItem = (id) => (dispatch, getState) => {
    const promotionalItems = selectors.getPromotionalItems(getState());

    let selectedItem = null;
    for (const promotionalItem of promotionalItems) {
        if (parseInt(promotionalItem.id) === parseInt(id)) {
            selectedItem = promotionalItem;
            break;
        }
    }

    dispatch({
        type: types.SET_PROMOTIONAL_ITEM,
        payload: selectedItem,
    })
}

export const resetPromotionalItem = () => (dispatch) => {
    dispatch({
        type: types.RESET_PROMOTIONAL_ITEM,
        payload: {},
    })
}

export const setSort = (column, type) => (dispatch) => {
    new Promise(resolve => {
        dispatch({
            type: types.SET_SORT,
            payload: { column, type }
        });
        resolve();
    }).then(() => {
        dispatch(fetchPromotionalItems());
    });
}

export const setSearch = (value) => dispatch => {
    dispatch({
        type: types.SET_SEARCH,
        payload: value,
    });
}

export const setSearchType = (value) => dispatch => {
    dispatch({
        type: types.SET_SEARCH_TYPE,
        payload: value,
    });
}

export const setPrice = (index, price) => dispatch => {
    dispatch({
        type: types.SET_PRICE,
        payload: { index, price },
    });
}

export const setEnabled = (index, enabled) => dispatch => {
    dispatch({
        type: types.SET_ENABLED,
        payload: { index, enabled },
    });
}